import { createContext, useContext } from 'react'

/**
 * 현재 구장 컨텍스트.
 *
 * 🚨 **진실의 원천은 URL**(`/venues/:venueId/...`)이다. `VenueLayout` 이 파라미터를 검증한 뒤
 * 이 컨텍스트로 내려주므로, 하위 화면은 파라미터 파싱·유효성 검사를 반복하지 않아도 되고
 * `venueId` 가 항상 양의 정수임을 타입으로 보장받는다.
 * `venueStore` 는 사이드바 표시용 미러일 뿐 조회 대상 결정에 쓰지 않는다.
 */
export interface VenueContextValue {
  venueId: string
}

export const VenueContext = createContext<VenueContextValue | null>(null)

export function useVenueContext(): VenueContextValue {
  const value = useContext(VenueContext)
  if (value === null) {
    throw new Error('useVenueContext 는 VenueLayout 하위에서만 사용할 수 있습니다.')
  }
  return value
}
